export const LocalStorageKey = {
  auth: 'hush_auth',
  log: 'hush_log',
  language: 'hush_language',
  theme: 'hush_theme',
}
